import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Table, Button } from "antd";
import moment from "moment";
import { getUser } from "../../../../../utils/helpers";
import EditSequence from "./EditSequence";
import { fetchSequenceTableData } from "../../../../../actions/chemistry";
import useAbortController from "../../../../Common/hooks/useAbortController";
import "./Sequence.css";

const Sequence = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const { setNewAbortController } = useAbortController();
  // const handleCreate = () => {
  //   setEditingRecord(null);
  //   setModalOpen(true);
  // };

  const handleEdit = (record) => {
    setEditingRecord(record);
    setModalOpen(true);
  };

  const columns = [
    {
      title: "Test Name",
      dataIndex: "test_internal_name",
      key: "test_internal_name",
      permission: "no-permission",
    },
    {
      title: "Instrument",
      dataIndex: "instrument_name",
      key: "instrument_name",
      permission: "no-permission",
    },
    {
      title: "Instrument Brand",
      dataIndex: "instrument_brand",
      key: "instrument_brand",
      permission: "no-permission",
    },
    {
      title: "Instrument Method",
      dataIndex: "instrument_method",
      key: "instrument_method",
      permission: "no-permission",
    },
    {
      title: "DF",
      dataIndex: "df",
      key: "df",
      permission: "view_extended_sequence_columns",
    },
    {
      title: "Fixed Pattern",
      dataIndex: "fixed_pattern",
      key: "fixed_pattern",
      permission: "view_extended_sequence_columns",
    },
    {
      title: "Repeated Pattern",
      dataIndex: "repeated_pattern",
      key: "repeated_pattern",
      permission: "view_extended_sequence_columns",
    },
    {
      title: "Folder",
      dataIndex: "folder_uq",
      key: "folder_uq",
      permission: "view_extended_sequence_columns",
    },
    {
      title: "Updated By",
      dataIndex: "last_updated_by",
      key: "last_updated_by",
      permission: "view_extended_sequence_columns",
      render: (_, record) => (
        <span>
          {record.last_updated_by ? record.last_updated_by : "-"}
        </span>
      ),
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "updated_at",
      permission: "view_extended_sequence_columns",
      render: (_, record) => (
        <span>
          {record.updated_at ? moment(record.updated_at).format(
            "MM/DD/YYYY, h:mm:ss a",
          ) : "-"}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      permission: "no-permission",
      width: "100px",
      render: (_, record) => (
        <Button
          onClick={() => handleEdit(record)}
        >
          Edit
        </Button>
      ),
    },
  ];
  const user = getUser();
  const authorizedColumns = columns.filter((col) => {
    const { permission } = col;
    return user.permissionMap[permission];
  });

  const fetchData = async () => {
    setLoading(true);
    const newAbortController = setNewAbortController();
    const {
      success, result, message, cancelled,
    } = await fetchSequenceTableData(newAbortController.signal);
    if (success) {
      setData(result.map((item, i) => ({ ...item, key: i })));
    } else if (!cancelled) {
      toast.error(message);
    }

    setLoading(cancelled);
  };

  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line

  const onCancelModal = (refresh = false) => {
    setModalOpen(false);
    if (refresh) {
      fetchData();
    }
  };

  return (
    <>
      {/* <Button type="primary" className="SequenceCreateBtn" onClick={handleCreate} disabled={loading}>
        Create new Sequence
      </Button> */}
      <Table
        sticky
        className="SequenceTable"
        loading={loading}
        columns={authorizedColumns}
        dataSource={data}
        pagination={false}
      />
      <EditSequence
        open={modalOpen}
        onCancel={onCancelModal}
        record={editingRecord}
        formInputs={authorizedColumns.filter((col) => {
          const alwaysExclude = ["action", "last_updated_by", "updated_at"];
          if (alwaysExclude.includes(col.key)) return false;
          return true;
        })}
      />

    </>
  );
};

export default Sequence;
